var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({attrs:{"rules":[_vm.requiredRule]},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }